import { Nav, Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import "./SideBar.css";

function SideNav({ onClose, isCollapsed = false, onToggleCollapse }) {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: "/dashboard", icon: "📊", label: "Dashboard" },
    { path: "/properties", icon: "🏠", label: "Properties" },
    { path: "/tenants", icon: "👥", label: "Tenants" },
    { path: "/applications", icon: "📋", label: "Applications" },
    // { path: "/users", icon: "👤", label: "Users" },
    // { path: "/settings", icon: "⚙️", label: "Settings" },
  ];

  const handleNavClick = (path) => {
    navigate(path);
    if (onClose) onClose();
  };

  return (
    <div className={`sidebar-nav ${isCollapsed ? "is-collapsed" : ""}`}>
      <div className="sidebar-header d-flex justify-content-between align-items-center">
        <h6 className="text-white p-3 mb-0 sidebar-title">
          {isCollapsed ? "REM" : "Real Estate Manager"}
        </h6>
        <Button
          variant="link"
          className="d-none d-md-inline-flex text-white collapse-toggle-btn"
          onClick={onToggleCollapse}
          title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {isCollapsed ? "»" : "«"}
        </Button>
        <Button variant="link" className="d-md-none text-white close-btn" onClick={onClose}>
          ✕
        </Button>
      </div>
      <Nav className="flex-column sidebar-nav-list">
        {navItems.map((item) => {
          const isActive =
            location.pathname === item.path || location.pathname.startsWith(`${item.path}/`);

          return (
            <Nav.Link
              key={item.path}
              onClick={() => handleNavClick(item.path)}
              className={`sidebar-link text-white py-2 px-3 ${isActive ? "active" : ""}`}
              style={{ cursor: "pointer" }}
              title={isCollapsed ? item.label : undefined}
            >
              <span className="sidebar-link-icon">{item.icon}</span>
              {!isCollapsed && <span className="sidebar-link-text">{item.label}</span>}
            </Nav.Link>
          );
        })}
      </Nav>
    </div>
  );
}

export default SideNav;
